
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  LegalFormsMapping,
} from '../models';
import {
    LegalFormsMappingFromJSON,
    LegalFormsMappingToJSON,
} from '../models';

export interface LegalsFormsMappingRequest {
    country: string;
}

/**
 * 
 */
export class LegalFormsApi extends runtime.BaseAPI {

    /**
          */
    async legalsFormsMappingRaw(requestParameters: LegalsFormsMappingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<LegalFormsMapping>>> {
        if (requestParameters['country'] == null) {
            throw new runtime.RequiredError(
                'country',
                'Required parameter "country" was null or undefined when calling legalsFormsMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<LegalFormsMapping>>({
            path: `/compliance/api/legal-forms-mapping/{country}`.replace(`{${"country"}}`, encodeURIComponent(String(requestParameters['country']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(LegalFormsMappingFromJSON);
        return response;
    }

    /**
          */
    async legalsFormsMapping(requestParameters: LegalsFormsMappingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<LegalFormsMapping>> {
        const response = await this.legalsFormsMappingRaw(requestParameters, initOverrides);
        return response._data;
    }

}
